import "../../i18n";
import {useTranslation} from "react-i18next";
import TextInput from "../../FormElements/TextInput";
import SimpleModal from "../Modal/SimpleModal";
import i18n from "i18next";
import {useEffect, useState} from "react";
import pfalzfreshLogo from '../../assets/images/pfalzfresh.jpg';
import gemuesegartenLogo from '../../assets/images/gemuesegarten.jpg';
import agb from '../../assets/pdf/AGB_Terms_RheinPfalz_GmbH.pdf';
import * as Icon from 'react-bootstrap-icons';
import axios, {formToJSON} from "axios";
import {APIBASE, ASSETSBASE} from "../../config/Pfalzmarkt.config";
import {useStore} from "../../store/store";
import {Link} from "react-router-dom";
import Turnstile, {useTurnstile} from "react-turnstile";
import {TURNSTILE_KEY} from "../../config/Pfalzmarkt.config";

export default function Neukunden() {
    const [globalState, dispatch] = useStore();
    const turnstile = useTurnstile();
    const {t} = useTranslation();
    const [formSend, setFormSend] = useState(true);
    const [step, setStep] = useState(1);
    const [validSteps, setValidSteps] = useState({1: false, 2: false, 3: false});
    const [differentCompanyDeliveryAddress, SetDifferentCompanyDeliveryAddress] = useState(false);
    const [error, setError] = useState({1: [], 2: [], 3: []});
    const [showModal, setShowModal] = useState(false);
    const [modalText, setModalText] = useState({
        title: t('newCustomerRequestTitle'),
        body: t('newCustomerRequestBody')
    });
    const errorMessages = {
        companyName: t('errorcompcompanyName'),
        companyStreet: t('errorcompcompanyStreet'),
        "companyZip": t('errorcompanyZip'),
        "companyCity": t('errorcompanyCity'),
        "companyUstId": t('errorcompanyUstId'),
        "companyCountry": t('errorcompanyCountry'),
        "companyIban": t('errorcompanyIban'),
        "companySwift": t('errorcompanySwift'),
        "companyMailBookKeeping": t('errorcompanyMailBookKeeping'),
        "companyMailInvoice": t('errorcompanyMailInvoice'),
        "companyCreditInsurance": t('errorcompanyCreditInsurance'),
        "CreditInsurance": t('errorCreditInsurance'),
        "errorCreditInsuranceCustomerNo": t('errorCreditInsuranceCustomerNo'),
        "errorcompanyPurchasEmail": t('errorcompanyPurchasEmail'),
        "errorcompanyPurchasePhone": t('errorcompanyPurchasePhone'),
        "errorcompanyBookKeepingEmail": t('errorcompanyBookKeepingEmail'),
        "errorcompanyBookKeepingPhone": t('errorcompanyBookKeepingPhone'),
        "errorcompanyQMEmail": t('errorcompanyQMEmail'),
        "errorcompanyQMPhone": t('errorcompanyQMPhone'),
        "errorcompanyDeliveryName": t('errorcompanyDeliveryName'),
        "errorcompanyDeliveryStreet": t('errorcompanyDeliveryStreet'),
        "errorcompanyDeliveryZip": t('errorcompanyDeliveryZip'),
        "errorcompanyDeliveryCity": t('errorcompanyDeliveryCity'),
        "errorcompanyDeliveryTaxId": t('errorcompanyDeliveryTaxId'),
        "errorcompanyDeliveryCountry": t('errorcompanyDeliveryCountry')
    }


    function sendForm(event) {
        event.preventDefault();
        let formData = formToJSON(event.target);
        formData.template = 'neukundenanfrage';
        formData.language = i18n.language;
        formData.differentCompanyDeliveryAddress = differentCompanyDeliveryAddress;
        axios({
            method: 'post',
            url: APIBASE + 'Api/form/sendMailGeneral',
            rejectUnauthorized: false,
            data: formData,
        }).then(result => {
            setShowModal(true);
            setFormSend(true);
            if (result.data !== true) {
                setModalText({title: t('newCustomerRequestTitleFalse'), body: t('newCustomerRequestBodyFalse')});
            }

        })
            .catch(error => {
                console.log(error);
            });
    }

    function setErrorSteps(step, name, errorMessage) {
        setError({[step]: {...error[step], ...{[name]: errorMessage}}});
    }

    function handleEmptyData(event) {
        if ('' === event.target.value) {
            setErrorSteps(step, event.target.name, errorMessages[event.target.name]);
        } else {
            setErrorSteps(step, event.target.name, null);
        }
        let countValidInputs = checkErrorStatus();

        if (countValidInputs[1] >= 10) {
            setValidSteps({...validSteps, ...{1: true}});
        } else {
            setValidSteps({...validSteps, ...{1: false}});
        }
    }

    function checkErrorStatus() {
        let countValidInputs = {1: 0, 2: 0, 3: 0}
        for (let i = 1; i <= 3; i++) {
            if (error[i]) {
                Object.keys(error[i]).forEach(key => {
                    if (error[i][key] == null) {
                        countValidInputs[i]++;
                    } else {
                        countValidInputs[i]--;
                    }
                });

            }
        }
        return countValidInputs;
    }

    const changeLanguage = (lang) => {

        i18n.changeLanguage(lang.target.value, (err, t) => {
            if (err) return console.log('something went wrong loading', err);
            t('key');
        });

    }

    useEffect(() => {
        dispatch('IS_401_ERROR', false);
        dispatch('SET_AUTHTOKEN', '');

    }, [globalState.token, globalState.is401Error]);

    return (
        <div className='container-fluid'>
            <SimpleModal show={showModal} onHide={() => setShowModal(false)}
                         content={modalText}/>


                <div className="row">
                        <div className="col-12" >
                            <img src={gemuesegartenLogo}
                                 style={{padding: '10px', border: '1px solid', height: '150px'}}
                                 alt={t('imgGemuesegaten')} />
                    </div>
                </div>


                <div className="container-fluid">
                    <form id="neukunden" onSubmit={sendForm}>
                        <div style={{display: step === 1 ? 'block' : 'none'}}>
                            <div className="row">
                                <div className="col-9">
                                    <h3>{t('companyData')}</h3>
                                </div>
                                <div className="col-3">
                                    <i className="bi bi-globe"></i><select onChange={(event) => changeLanguage(event)}>
                                    <option value="de">Deutsch</option>
                                    <option value="en">English</option>
                                </select>
                                </div>
                            </div>
                            <TextInput name="companyName" onChange={handleEmptyData}
                                       error={error && error[1].companyName}/>
                            <TextInput name="companyStreet" onChange={handleEmptyData}
                                       error={error && error[1].companyStreet}/>
                            <TextInput name="companyZip" onChange={handleEmptyData}
                                       error={error && error[1].companyZip}/>
                            <TextInput name="companyCity" onChange={handleEmptyData}
                                       error={error && error[1].companyCity}/>
                            <TextInput name="companyUstId" onChange={handleEmptyData}
                                       error={error && error[1].companyUstId}/>
                            <TextInput name="companyCountry" onChange={handleEmptyData}
                                       error={error && error[1].companyCountry}/>
                            <TextInput name="companyKnowUsFrom"/>
                            <div className="row">
                                <div className="col-9">
                                    <h3>{t('companyBankData')}</h3>
                                </div>
                            </div>
                            <TextInput name="companyIban" onChange={handleEmptyData}
                                       error={error && error[1].companyIban}/>
                            <TextInput name="companySwift" onChange={handleEmptyData}
                                       error={error && error[1].companySwift}/>
                            <TextInput name="companyMailBookKeeping" onChange={handleEmptyData}
                                       error={error && error[1].companyMailBookKeeping}/>
                            <TextInput name="companySepa"/>
                            <TextInput name="companyRefund" onChange={handleEmptyData}
                                       error={error && error[1].companyRefund}/>
                            <TextInput name="companyMailInvoice"/>
                            <div className="row">
                                <div className="col-9">
                                    <h3>{t('companyCreditInsurance')}</h3>
                                </div>
                            </div>
                            <select className="form-control" name="CreditInsuranceSelect">
                                <option></option>
                                <option value="Euler-Hermes – DE">Euler-Hermes – DE</option>
                                <option value="Coface – FR">Coface – FR</option>
                                <option value="Groupama – FR">Groupama – FR</option>
                                <option value="Atradius – NL">Atradius – NL</option>
                            </select>
                            <TextInput name="CreditInsurance" onChange={handleEmptyData}
                                       error={error && error[1].CreditInsurance}/>
                            <TextInput name="CreditInsuranceCustomerNo" onChange={handleEmptyData}
                                       error={error && error[1].CreditInsuranceCustomerNo}/>
                            <div className="row">
                                <div className="col-9">
                                    <h3>{t('companyPurchaseDep')}</h3>
                                </div>
                            </div>
                            <TextInput name="companyPurchaseEmail" onChange={handleEmptyData}
                                       error={error && error[1].companyPurchaseEmail}/>
                            <TextInput name="companyPurchasePhone" onChange={handleEmptyData}
                                       error={error && error[1].companyPurchasePhone}/>
                            <div className="row">
                                <div className="col-9">
                                    <h3>{t('companyBookKeeping')}</h3>
                                </div>
                            </div>
                            <TextInput name="companyBookKeepingEmail" onChange={handleEmptyData}
                                       error={error && error[1].companyBookKeepingEmail}/>
                            <TextInput name="companyBookKeepingPhone" onChange={handleEmptyData}
                                       error={error && error[1].companyBookKeepingPhone}/>
                            <div className="row">
                                <div className="col-9">
                                    <h3>{t('companyQualityManagement')}</h3>
                                </div>
                            </div>
                            <TextInput name="companyQMEmail" onChange={handleEmptyData}
                                       error={error && error[1].companyQMEmail}/>
                            <TextInput name="companyQMPhone" onChange={handleEmptyData}
                                       error={error && error[1].companyQMPhone}/>
                            <div className="row">
                                <div className="col-9">
                                    <button type="button" className='btn btn-secondary btn-sm'
                                            onClick={() => SetDifferentCompanyDeliveryAddress(!differentCompanyDeliveryAddress)}>{t('companydeliveyAddress')}</button>
                                </div>
                            </div>
                            {differentCompanyDeliveryAddress &&
                                <>
                                    <div className="row">
                                        <div className="col-9">
                                            <h3>{t('companydeliveyAddress')}</h3>
                                        </div>
                                    </div>
                                    <TextInput name="companyDeliveryName" onChange={handleEmptyData}
                                               error={error && error[1].companyDeliveryName}/>
                                    <TextInput name="companyDeliveryStreet" onChange={handleEmptyData}
                                               error={error && error[1].companyDeliveryStreet}/>
                                    <TextInput name="companyDeliveryZip" onChange={handleEmptyData}
                                               error={error && error[1].companyDeliveryZip}/>
                                    <TextInput name="companyDeliveryCity" onChange={handleEmptyData}
                                               error={error && error[1].companyDeliveryCity}/>
                                    <TextInput name="companyDeliveryTaxId" onChange={handleEmptyData}
                                               error={error && error[1].companyDeliveryTaxId}/>
                                    <TextInput name="companyDeliveryCountry" onChange={handleEmptyData}
                                               error={error && error[1].companyDeliveryCountry}/>
                                </>
                            }
                            <div className="row">
                                <div className="col-sm-12 col-md-3">
                                    <button name="step2" type="button" disabled={!validSteps[1]}
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => setStep(2)}>{t('Forward')}</button>
                                </div>
                            </div>
                        </div>

                        <div style={{display: step === 2 ? 'block' : 'none'}}>
                            <div className="row">
                                <div className="col-9">
                                    <h3>{t('companyConditions')}</h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 col-sm-12">
                                    <input type="checkbox" name="condAccepted" value="1" onChange={(event) => {
                                        setValidSteps({...validSteps, ...{2: event.target.checked}});
                                    }}/>
                                </div>
                                <div className="col-lg-3 col-sm-12">
                                    <p>{t('companyAcceptConditions')}x</p>
                                    <Link to={'../' + agb} target='_blank'>Download</Link>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-3">
                                    <button type="button" className="btn btn-secondary btn-sm" disabled={!validSteps[2]}
                                            onClick={() => setStep(3)}>{t('Forward')}
                                    </button>
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <button type="button" className="btn btn-secondary btn-sm"
                                            onClick={() => setStep(1)}>{t('Back')}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div style={{display: step === 3 ? 'block' : 'none'}}>
                            <div className="row">
                                <div className="col-9">
                                    <h3>{t('companyOverview')}</h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-3">
                                    <Icon.CheckLg color='green' size="30"/><strong>{t('companyData')}</strong><br/>
                                    <Icon.CheckLg color='green'
                                                  size="30"/><strong>{t('companyBankData')}</strong><br/>
                                    <Icon.CheckLg color='green'
                                                  size="30"/><strong>{t('companyCreditInsurance')}</strong><br/>
                                    <Icon.CheckLg color='green'
                                                  size="30"/><strong>{t('companyPurchaseDep')}</strong><br/>
                                    <Icon.CheckLg color='green'
                                                  size="30"/><strong>{t('companyBookKeeping')}</strong><br/>
                                    {differentCompanyDeliveryAddress && <><Icon.CheckLg color='green'
                                                                                        size="30"/><strong>{t('companydeliveyAddress')}</strong></>}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-3">
                                    <Turnstile
                                        sitekey={TURNSTILE_KEY}
                                        onVerify={(token) => {
                                            setFormSend(false);

                                        }}
                                    />
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <button type="submit" className="btn btn-secondary btn-sm"
                                            disabled={formSend}>Senden
                                    </button>
                                </div>
                                <div className="col-sm-12 col-md-3">
                                    <button type="button" className="btn btn-secondary btn-sm"
                                            onClick={() => setStep(2)}>{t('Back')}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>

        </div>
    );
}


